import $ from 'jquery'
import createSearchSlider from './search-slider'; // adjust path
const searchSlider = createSearchSlider();

export default () => {
  function init() {
    class PredictiveSearch extends HTMLElement {
      constructor() {
        super();
        
        var constructor = this;
        this.input = this.querySelector('input[type="search"]');
        this.predictiveSearchResults = this.querySelector('#predictive-search');

        this.input.addEventListener('input', this.debounce((event) => {
          this.onChange(event);
        }, 300).bind(this));

        $('.search-opener').on('click', function(){
          var input = $('#Search');
          var value = $(input).val();
          setTimeout(() => {
            constructor.getSearchResults(value)
          }, 200);
        })

        if($('body').hasClass('search')){
          var input = $('#Search');
          var value = $(input).val();
          setTimeout(() => {
            constructor.getSearchResultsNew(value)
          }, 500);
          document.getElementById('predictive-search').display = 'none!important';
        }

        $(document).on('click', '#predictive-search .single-item-query', function(){
          var value = $(this).text().trimStart().trimEnd();
          var input = $('#Search');
          $(input).val(value).trigger('change');
          
          setTimeout(() => {
            constructor.getSearchResults(value)
          }, 200);
        });

        $(document).on('click', '.template-search-wrap-holder .single-item-query', function(){
          var value = $(this).text().trimStart().trimEnd();
          var input = $('#Search');
          $(input).val(value).trigger('change');
          
          setTimeout(() => {
            $('.search-form').submit();
          }, 200);
        });
        
      }

      onChange() {
        const searchTerm = this.input.value.trim();

        if (!searchTerm.length) {
          this.predictiveSearchResults.innerHTML = '';
          if($('body').hasClass('search')){
            document.getElementById('predictive-search-new').innerHTML = '';
          }

          $('predictive-search form').removeClass('with-height')
          return;
        }

        this.getSearchResults(searchTerm);
      }

      getSearchResults(searchTerm) {
        fetch(`/search/suggest?q=${searchTerm}&resources[limit]=6&resources[limit_scope]=each&resources[options][fields]=title,product_type&section_id=predictive-search`)
          .then((response) => {
            if (!response.ok) {
              var error = new Error(response.status);
              this.close();
              throw error;
            }

            return response.text();
          })
          .then((text) => {
            $('predictive-search form').addClass('with-height')
            const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
            this.predictiveSearchResults.innerHTML = resultsMarkup;
            
            requestAnimationFrame(() => {
              searchSlider.init(this.predictiveSearchResults);
            });

            if ($('body').hasClass('search')) {
              const newRoot = document.getElementById('predictive-search-new');
              newRoot.innerHTML = resultsMarkup;

              requestAnimationFrame(() => {
                searchSlider.init(newRoot);
              });
            }

            this.open();
          })
          .catch((error) => {
            this.close();
            throw error;
          });

          setTimeout(() => {
            var final_val = this.value;

            const myHeaders = new Headers();
            myHeaders.append("Authorization", "Basic aUlNblZtZGhwSExZM1pWanE1ank=");
            myHeaders.append("Cookie", "_x_w=45_2");
          
            const requestOptions = {
              method: "GET",
              headers: myHeaders,
              redirect: "follow"
            };
          
            fetch(`https://mod-bikes.freshdesk.com/api/v2/search/solutions?term=${searchTerm}&limit=4`, requestOptions)
              .then(response => response.json())
              .then(result => {
                if (result && result.length > 0) {
                  
                  var filterContDiv = document.querySelectorAll('.help-center-result-list');

                  filterContDiv.forEach((userItem) => {
                    result.forEach((item, index) => {
                      var title = item.title; 
                      var path = item.path; 
                      userItem.innerHTML += `<div id="predictive-search-option-page-desktop-${index}" class="single-item-list" role="option" aria-selected="false">
                                <a href="https://mod-bikes.freshdesk.com/support/solutions/articles/${path}" class="predictive-search__item" target="_blank" tabindex="-1">
                                  <div class="predictive-search__item-content predictive-search__item-content--centered">
                                    <p class="predictive-search__item-heading h5">${title}</p>
                                  </div>
                                  <img src="https://cdn.shopify.com/s/files/1/0325/8925/0700/files/page.svg?v=1739460788" />
                                </a>
                              </div>`;
                  });
                  if (result && result.length > 4) {
                    $('.more-help-link').css('display', 'block')
                  }
                  })
                document.querySelector('.help-loader').style.display = 'none';
                
              } else {
                
                  $('.more-help-link').css('display', 'none')
                  document.querySelector('.help-loader').style.display = 'none';
                  var filterContDiv = document.querySelector('.help-center-result-list');
                  if(searchTerm.length < 2){
                    filterContDiv.innerHTML = `<p>Needs to have more than 2 letters in search</p>`;
                  } else{
                    filterContDiv.innerHTML = `<p>No Result Found for: ${searchTerm}</p>`;
                  }
                }
              })
              // .catch(error => console.error(error));
          }, 300);
      }

      getSearchResultsNew(searchTerm) {
        fetch(`/search/suggest?q=${searchTerm}&resources[limit]=6&resources[limit_scope]=each&resources[options][fields]=title,product_type&section_id=predictive-search`)
          .then((response) => {
            if (!response.ok) {
              var error = new Error(response.status);
              this.close();
              throw error;
            }

            return response.text();
          })
          .then((text) => {
            $('predictive-search form').addClass('with-height');

              const resultsMarkup = new DOMParser()
                .parseFromString(text, 'text/html')
                .querySelector('#shopify-section-predictive-search').innerHTML;

              const newRoot = document.getElementById('predictive-search-new');
              newRoot.innerHTML = resultsMarkup;

              requestAnimationFrame(() => {
                searchSlider.init(newRoot);
              });
          })
          .catch((error) => {
            this.close();
            throw error;
          });

          setTimeout(() => {
            var final_val = this.value;

            const myHeaders = new Headers();
            myHeaders.append("Authorization", "Basic aUlNblZtZGhwSExZM1pWanE1ank=");
            myHeaders.append("Cookie", "_x_w=45_2");
          
            const requestOptions = {
              method: "GET",
              headers: myHeaders,
              redirect: "follow"
            };
          
            fetch(`https://mod-bikes.freshdesk.com/api/v2/search/solutions?term=${searchTerm}&limit=4`, requestOptions)
              .then(response => response.json())
              .then(result => {
                if (result && result.length > 0) {
                  
                  var filterContDiv = document.querySelector('.help-center-result-list');
                  result.forEach((item, index) => {
                    var title = item.title; 
                    var path = item.path; 
                    filterContDiv.innerHTML += `<div id="predictive-search-option-page-desktop-${index}" class="single-item-list" role="option" aria-selected="false">
                              <a href="https://mod-bikes.freshdesk.com/support/solutions/articles/${path}" class="predictive-search__item" target="_blank" tabindex="-1">
                                <div class="predictive-search__item-content predictive-search__item-content--centered">
                                  <p class="predictive-search__item-heading h5">${title}</p>
                                </div>
                                <img src="https://cdn.shopify.com/s/files/1/0325/8925/0700/files/page.svg?v=1739460788" />
                              </a>
                            </div>`;
                });
                if (result && result.length > 4) {
                  $('.more-help-link').css('display', 'block')
                }
                document.querySelector('.help-loader').style.display = 'none';
                
              } else {
                
                  $('.more-help-link').css('display', 'none')
                  document.querySelector('.help-loader').style.display = 'none';
                  var filterContDiv = document.querySelector('.help-center-result-list');
                  if(searchTerm.length < 2){
                    filterContDiv.innerHTML = `<p>Needs to have more than 2 letters in search</p>`;
                  } else{
                    filterContDiv.innerHTML = `<p>No Result Found for: ${searchTerm}</p>`;
                  }
                }
              })
              // .catch(error => console.error(error));
          }, 300);
      }

      open() {
        this.predictiveSearchResults.style.display = 'block';
        predictiveSerachFilter()
      }

      close() {
        this.predictiveSearchResults.style.display = 'none';
      }

      debounce(fn, wait) {
        let t;
        return (...args) => {
          clearTimeout(t);
          t = setTimeout(() => fn.apply(this, args), wait);
        };
      }
    }

    customElements.define('predictive-search', PredictiveSearch);

    $('.search-opener').on('click', function(){
      $('body').addClass('no-search-scroll')
      $('predictive-search').addClass('active')
      $('.search-overaly').fadeIn('fast')
      $('input[type="search"]').focus()

      if($('.announcement-bar').length){
        if ($(window).scrollTop() > 20) {
          $('predictive-search').addClass('no-bar');
        } else {
          $('predictive-search').removeClass('no-bar');
        }
      }
    })

    $('.search-close, .search-overaly').on('click', function(){
      // $('input[type="search"]').val('')
      $('predictive-search form').removeClass('with-height')
      $('body').removeClass('no-search-scroll')
      $('.search-overaly').fadeOut('fast')
      $('predictive-search').removeClass('active no-bar')
      $('body').removeClass('no-search-scroll')
      $('#predictive-search').css('display', 'none')
    })
  }

  function predictiveSerachFilter(){
    $('.predictive-search-content .filter').removeClass('active')
    $('.predictive-search-content .filter').first().addClass('active')

    predictiveSerachFilterClick()

    $('.predictive-search-content .filter').on('click', function(){
      $('.predictive-search-content .filter').removeClass('active')
      $(this).addClass('active')
      predictiveSerachFilterClick()
    })
  }

  function predictiveSerachFilterClick(){
    $( ".predictive-search-content .single-results" ).each(function( index ) {
      if($(this).data('results') == $('.predictive-search-content .filter.active').data('filter')){
        if($(this).hasClass('single-results-flex-list')){
          $(this).css('display', 'flex')
        } else{
          $(this).css('display', 'block')
        }

      } else{
        $(this).css('display', 'none')
      }
    });
  }

  return Object.freeze({
    init
  })
}
